import React from 'react';
import { Product } from 'data/terra/Product';
import { CaretRightFilled } from '@ant-design/icons';
import './ProjectHeadIcon.scss';
import DefaultProjectIcon from 'v2/components/project/DefaultProjectIcon';

interface ProjectHeadIconProps {
  project: Product | undefined | null;
  collapsed: boolean;
  onClick: (project: Product) => void;
}

const ProjectHeadIcon: React.FC<ProjectHeadIconProps> = props => {
  return (
    <div
      className="project-head-icon-name-container"
      onClick={() => {
        if (props.project) props.onClick(props.project);
      }}
    >
      {props.project?.logo ? (
        <div className="project-head-icon-default-icon">
          <img src={props.project?.logo} alt="logo" width={40} height={40} className='bordered-image' />
        </div>
      ) : (
        <div className="project-head-icon-default-icon">
          <DefaultProjectIcon projectName={props.project?.name ?? ''} />
        </div>
      )}
      {!props.collapsed && (
        <span className="project-head-icon-name">{props.project?.name}</span>
      )}
      <div style={{ flex: 1 }} />
      {!props.collapsed && <CaretRightFilled width={24} height={24} />}
    </div>
  );
};

export default ProjectHeadIcon;
